import { lazy } from "react";
import Dashboard from "views/dashboard/Dashboard.js";
import Login from "views/auth/Login.js";
import { PERMISSIONS } from "services/roles";
import { filterConsumerLegalRoutes } from "config/features";
const FilesList = lazy(() => import("views/files/FilesList.js"));
const FileDetail = lazy(() => import("views/files/FileDetail.js"));
const FileUpload = lazy(() => import("views/files/FileUpload.js"));
const FileShare = lazy(() => import("views/files/FileShare.js"));
const FileVersionHistory = lazy(() => import("views/files/FileVersionHistory.js"));
const FilePreview = lazy(() => import("views/files/FilePreview.js"));
const FolderManage = lazy(() => import("views/files/FolderManage.js"));
const Trash = lazy(() => import("views/files/Trash.js"));
const Retention = lazy(() => import("views/files/Retention.js"));
const AIChat = lazy(() => import("views/ai/AIChat.js"));
const OCRResult = lazy(() => import("views/ai/OCRResult.js"));
const AiAnalysisHub = lazy(() => import("views/ai/AiAnalysisHub.js"));
const Search = lazy(() => import("views/search/Search.js"));
const Settings = lazy(() => import("views/settings/Settings.js"));
const Profile = lazy(() => import("views/settings/Profile.js"));
const AdminPanel = lazy(() => import("views/settings/AdminPanel.js"));
const LicenseRenewal = lazy(() => import("views/settings/LicenseRenewal.js"));
const SupportTickets = lazy(() => import("views/support/SupportTickets.js"));
const NewSupportTicket = lazy(() => import("views/support/NewSupportTicket.js"));
const SupportTicketDetail = lazy(() => import("views/support/SupportTicketDetail.js"));
const SupportAccessViewer = lazy(() => import("views/support/SupportAccessViewer.js"));
const Notifications = lazy(() => import("views/settings/Notifications.js"));
const Security = lazy(() => import("views/settings/Security.js"));
const WorkspaceSelector = lazy(() => import("views/settings/WorkspaceSelector.js"));
const Organization = lazy(() => import("views/settings/Organization.js"));
const AIDataProcessing = lazy(() => import("views/settings/AIDataProcessing.js"));
const PrivacyRequests = lazy(() => import("views/settings/PrivacyRequests.js"));
const LicenseVerification = lazy(() => import("views/settings/LicenseVerification.js"));
const PrivacyPolicy = lazy(() => import("views/legal/PrivacyPolicy.js"));
const TermsOfService = lazy(() => import("views/legal/TermsOfService.js"));
const KvkkNotice = lazy(() => import("views/legal/LegalDocumentPage.js").then((m) => ({ default: m.KvkkNotice })));
const DistanceSalesAgreement = lazy(() => import("views/legal/LegalDocumentPage.js").then((m) => ({ default: m.DistanceSalesAgreement })));
const DeliveryConditions = lazy(() => import("views/legal/LegalDocumentPage.js").then((m) => ({ default: m.DeliveryConditions })));
const CancellationReturn = lazy(() => import("views/legal/LegalDocumentPage.js").then((m) => ({ default: m.CancellationReturn })));
const Register = lazy(() => import("views/auth/Register.js"));
const LicenseLookup = lazy(() => import("views/auth/LicenseLookup.js"));
const LicenseInfo = lazy(() => import("views/auth/LicenseInfo.js"));
const SupportRequest = lazy(() => import("views/auth/SupportRequest.js"));
const InvoiceList = lazy(() => import("views/accounting/InvoiceList.js"));
const InvoiceDetail = lazy(() => import("views/accounting/InvoiceDetail.js"));
const InvoiceCreate = lazy(() => import("views/accounting/InvoiceCreate.js"));
const InvoiceOCR = lazy(() => import("views/accounting/InvoiceOCR.js"));
const Accounts = lazy(() => import("views/accounting/Accounts.js"));
const ExchangeRates = lazy(() => import("views/accounting/ExchangeRates.js"));
const AccountDetail = lazy(() => import("views/accounting/AccountDetail.js"));
const ApprovalList = lazy(() => import("views/accounting/ApprovalList.js"));
const ApprovalDetail = lazy(() => import("views/accounting/ApprovalDetail.js"));
const ProductList = lazy(() => import("views/inventory/ProductList.js"));
const ProductDetail = lazy(() => import("views/inventory/ProductDetail.js"));
const ProductCreate = lazy(() => import("views/inventory/ProductCreate.js"));
const StockMovements = lazy(() => import("views/inventory/StockMovements.js"));
const StockEntry = lazy(() => import("views/inventory/StockEntry.js"));
const ShipmentDocuments = lazy(() => import("views/inventory/ShipmentDocuments.js"));
const PurchaseRequests = lazy(() => import("views/inventory/PurchaseRequests.js"));
const SerialTracking = lazy(() => import("views/inventory/SerialTracking.js"));
const LotTracking = lazy(() => import("views/inventory/LotTracking.js"));
const StockOverview = lazy(() => import("views/inventory/StockOverview.js"));
const Traceability = lazy(() => import("views/inventory/Traceability.js"));
const Reservations = lazy(() => import("views/inventory/Reservations.js"));
const Replenishment = lazy(() => import("views/inventory/Replenishment.js"));
const StockCounts = lazy(() => import("views/inventory/StockCounts.js"));
const WarehouseReports = lazy(() => import("views/inventory/WarehouseReports.js"));
const InventoryPolicies = lazy(() => import("views/inventory/InventoryPolicies.js"));
const WarehouseList = lazy(() => import("views/inventory/WarehouseList.js"));
const WarehouseDetail = lazy(() => import("views/inventory/WarehouseDetail.js"));
const GoodsReceipt = lazy(() => import("views/inventory/GoodsReceipt.js"));
const StockTransfer = lazy(() => import("views/inventory/StockTransfer.js"));
const MasterData = lazy(() => import("views/foundation/MasterData.js"));
const UsersManage = lazy(() => import("views/foundation/UsersManage.js"));
const AuditLogs = lazy(() => import("views/foundation/AuditLogs.js"));
const SupplierList = lazy(() => import("views/procurement/SupplierList.js"));
const SupplierDetail = lazy(() => import("views/procurement/SupplierDetail.js"));
const RfqList = lazy(() => import("views/procurement/RfqList.js"));
const PurchaseOrderList = lazy(() => import("views/procurement/PurchaseOrderList.js"));
const ProductionPlanList = lazy(() => import("views/manufacturing/ProductionPlanList.js"));
const ManufacturingOrderList = lazy(() => import("views/manufacturing/ManufacturingOrderList.js"));
const MrpPlanning = lazy(() => import("views/manufacturing/MrpPlanning.js"));
const PickWaves = lazy(() => import("views/sales/PickWaves.js"));
const ManufacturingOrderDetail = lazy(() => import("views/manufacturing/ManufacturingOrderDetail.js"));
const QualityPlanList = lazy(() => import("views/quality/QualityPlanList.js"));
const InspectionList = lazy(() => import("views/quality/InspectionList.js"));
const NonConformanceList = lazy(() => import("views/quality/NonConformanceList.js"));
const FinishedGoodsList = lazy(() => import("views/packaging/FinishedGoodsList.js"));
const PackagingList = lazy(() => import("views/packaging/PackagingList.js"));
const FreightForwarderList = lazy(() => import("views/export/FreightForwarderList.js"));
const ExportOrderList = lazy(() => import("views/export/ExportOrderList.js"));
const InternationalShipmentList = lazy(() => import("views/export/InternationalShipmentList.js"));
const ContainerList = lazy(() => import("views/export/ContainerList.js"));
const CustomsList = lazy(() => import("views/export/CustomsList.js"));
const OverseasWarehouseList = lazy(() => import("views/export/OverseasWarehouseList.js"));
const CustomerList = lazy(() => import("views/sales/CustomerList.js"));
const PriceListList = lazy(() => import("views/sales/PriceListList.js"));
const SalesOrderList = lazy(() => import("views/sales/SalesOrderList.js"));
const FulfillmentBoard = lazy(() => import("views/sales/FulfillmentBoard.js"));
const ReturnList = lazy(() => import("views/afterSales/ReturnList.js"));
const RmaList = lazy(() => import("views/afterSales/RmaList.js"));
const WarrantyList = lazy(() => import("views/afterSales/WarrantyList.js"));
const ServiceOrderList = lazy(() => import("views/afterSales/ServiceOrderList.js"));
const ApprovalInbox = lazy(() => import("views/enterprise/ApprovalInbox.js"));
const NotificationEngine = lazy(() => import("views/enterprise/NotificationEngine.js"));
const FinanceIntegration = lazy(() => import("views/enterprise/FinanceIntegration.js"));
const ScmReports = lazy(() => import("views/enterprise/ScmReports.js"));

var routes = [

{
  path: "/dashboard",
  name: "Dashboard",
  nameKey: "nav.dashboard",
  icon: "ni ni-tv-2 text-primary",
  component: <Dashboard />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.DASHBOARD_ACCESS
},
{
  path: "/files",
  name: "Files",
  nameKey: "nav.files",
  icon: "ni ni-folder-17 text-orange",
  component: <FilesList />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.FILES_READ
},
{
  path: "/trash",
  name: "Trash",
  nameKey: "nav.trash",
  icon: "ni ni-basket text-danger",
  component: <Trash />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.FILES_READ
},
{
  path: "/retention",
  name: "Retention",
  nameKey: "nav.retention",
  icon: "ni ni-archive-2 text-default",
  component: <Retention />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.FILES_READ
},
{
  path: "/search",
  name: "Search",
  nameKey: "nav.search",
  icon: "ni ni-zoom-split-in text-info",
  component: <Search />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.SEARCH_ACCESS
},
{
  path: "/ai-chat",
  name: "AI Assistant",
  nameKey: "nav.aiAssistant",
  icon: "ni ni-chat-round text-success",
  component: <AIChat />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.AI_ACCESS
},
{
  path: "/ai/analysis",
  name: "AI Analysis",
  nameKey: "aiAnalysis.hubTitle",
  icon: "ni ni-atom text-info",
  component: <AiAnalysisHub />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.AI_ACCESS
},
{
  path: "/support",
  name: "Support",
  nameKey: "nav.support",
  icon: "ni ni-support-16 text-warning",
  component: <SupportTickets />,
  layout: "/admin",
  sidebar: true,
  hideInDemo: true
},
{
  path: "/support/new",
  name: "New Support Ticket",
  nameKey: "nav.support",
  component: <NewSupportTicket />,
  layout: "/admin",
  hideInDemo: true
},
{
  path: "/support/:ticketId",
  name: "Support Ticket",
  nameKey: "nav.support",
  component: <SupportTicketDetail />,
  layout: "/admin",
  hideInDemo: true
},
{
  path: "/support-access/:grantId",
  name: "Support Access",
  nameKey: "nav.support",
  component: <SupportAccessViewer />,
  layout: "/admin",
  hideInDemo: true
},
{
  path: "/admin-panel",
  name: "Admin Panel",
  nameKey: "nav.adminPanel",
  icon: "ni ni-badge text-danger",
  component: <AdminPanel />,
  layout: "/admin",
  sidebar: true,
  hideInDemo: true,
  permission: PERMISSIONS.ACCESS_ADMIN_PANEL
},
{
  path: "/license-renewal",
  name: "License Renewal",
  nameKey: "nav.licenseRenewal",
  component: <LicenseRenewal />,
  layout: "/admin",
  hideInDemo: true,
  permission: PERMISSIONS.ACCESS_ADMIN_PANEL
},
{
  path: "/foundation/users",
  name: "Users",
  nameKey: "nav.users",
  icon: "ni ni-single-02 text-primary",
  component: <UsersManage />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.FOUNDATION_USERS
},
{
  path: "/foundation/master-data",
  name: "Master Data",
  nameKey: "nav.masterData",
  icon: "ni ni-collection text-info",
  component: <MasterData />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.MASTER_DATA_READ
},
{
  path: "/foundation/audit",
  name: "Audit Log",
  nameKey: "nav.auditLog",
  icon: "ni ni-bullet-list-67 text-dark",
  component: <AuditLogs />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.AUDIT_READ
},
{
  path: "/accounting/invoices",
  name: "Accounting",
  nameKey: "nav.accounting",
  icon: "ni ni-money-coins text-yellow",
  component: <InvoiceList />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.ACCOUNTING_READ
},
{
  path: "/accounting/accounts",
  name: "Current Accounts",
  nameKey: "nav.accounts",
  icon: "ni ni-book-bookmark text-info",
  component: <Accounts />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.ACCOUNTING_READ
},
{
  path: "/accounting/exchange-rates",
  name: "Exchange Rates",
  nameKey: "nav.exchangeRates",
  icon: "fas fa-exchange-alt text-success",
  component: <ExchangeRates />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.ACCOUNTING_READ
},
{
  path: "/accounting/approvals",
  name: "Approvals",
  nameKey: "nav.approvals",
  icon: "ni ni-badge text-warning",
  component: <ApprovalList />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.APPROVALS_READ
},
{
  path: "/inventory/products",
  name: "Warehouse / Stock",
  nameKey: "nav.inventory",
  icon: "ni ni-box-2 text-default",
  component: <ProductList />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.INVENTORY_READ
},
{
  path: "/inventory/movements",
  name: "Inventory Movements",
  nameKey: "nav.movements",
  icon: "ni ni-archive-2 text-default",
  component: <StockMovements />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.INVENTORY_READ
},
{
  path: "/inventory/warehouses",
  name: "Warehouses",
  nameKey: "nav.warehouses",
  icon: "ni ni-building text-default",
  component: <WarehouseList />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.INVENTORY_READ
},
{
  path: "/inventory/stock-overview",
  name: "Stock Overview",
  nameKey: "nav.stockOverview",
  icon: "ni ni-chart-bar-32 text-info",
  component: <StockOverview />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.INVENTORY_READ
},
{
  path: "/inventory/reservations",
  name: "Reservations",
  nameKey: "nav.reservations",
  icon: "ni ni-lock-circle-open text-info",
  component: <Reservations />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.INVENTORY_READ
},
{
  path: "/inventory/replenishment",
  name: "Replenishment",
  nameKey: "nav.replenishment",
  icon: "ni ni-delivery-fast text-success",
  component: <Replenishment />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.INVENTORY_READ
},
{
  path: "/inventory/stock-counts",
  name: "Stock Counts",
  nameKey: "nav.stockCounts",
  icon: "ni ni-check-bold text-primary",
  component: <StockCounts />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.INVENTORY_READ
},
{
  path: "/inventory/reports",
  name: "Warehouse Reports",
  nameKey: "nav.warehouseReports",
  icon: "ni ni-chart-bar-32 text-info",
  component: <WarehouseReports />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.INVENTORY_READ
},
{
  path: "/inventory/policies",
  name: "Inventory Policies",
  nameKey: "nav.inventoryPolicies",
  icon: "ni ni-settings text-default",
  component: <InventoryPolicies />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.INVENTORY_WRITE
},
{
  path: "/inventory/traceability",
  name: "Traceability",
  nameKey: "nav.traceability",
  icon: "ni ni-vector text-warning",
  component: <Traceability />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.INVENTORY_READ
},
{
  path: "/inventory/goods-receipts",
  name: "Goods Receipt",
  nameKey: "nav.goodsReceipt",
  icon: "ni ni-check-bold text-success",
  component: <GoodsReceipt />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.INVENTORY_READ
},
{
  path: "/inventory/transfer",
  name: "Stock Transfer",
  nameKey: "nav.stockTransfer",
  icon: "ni ni-delivery-fast text-info",
  component: <StockTransfer />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.INVENTORY_WRITE
},
{
  path: "/inventory/shipments",
  name: "Shipment Documents",
  nameKey: "nav.shipments",
  icon: "ni ni-delivery-fast text-default",
  component: <ShipmentDocuments />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.INVENTORY_READ
},
{
  path: "/inventory/purchase-requests",
  name: "Purchase Requests",
  nameKey: "nav.purchaseRequests",
  icon: "ni ni-cart text-danger",
  component: <PurchaseRequests />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.INVENTORY_READ
},
{
  path: "/procurement/suppliers",
  name: "Suppliers",
  nameKey: "nav.suppliers",
  icon: "ni ni-building text-info",
  component: <SupplierList />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.PROCUREMENT_READ
},
{
  path: "/procurement/rfqs",
  name: "RFQs",
  nameKey: "nav.rfqs",
  icon: "ni ni-send text-warning",
  component: <RfqList />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.PROCUREMENT_READ
},
{
  path: "/procurement/purchase-orders",
  name: "Purchase Orders",
  nameKey: "nav.purchaseOrders",
  icon: "ni ni-single-copy-04 text-success",
  component: <PurchaseOrderList />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.PROCUREMENT_READ
},
{
  path: "/manufacturing/plans",
  name: "Production Plans",
  nameKey: "nav.productionPlans",
  icon: "ni ni-calendar-grid-58 text-warning",
  component: <ProductionPlanList />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.MANUFACTURING_READ
},
{
  path: "/manufacturing/mrp",
  name: "MRP",
  nameKey: "nav.mrp",
  icon: "ni ni-chart-bar-32 text-warning",
  component: <MrpPlanning />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.MANUFACTURING_READ
},
{
  path: "/manufacturing/orders",
  name: "Manufacturing Orders",
  nameKey: "nav.manufacturingOrders",
  icon: "ni ni-settings text-warning",
  component: <ManufacturingOrderList />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.MANUFACTURING_READ
},
{
  path: "/quality/plans",
  name: "Quality Plans",
  nameKey: "nav.qualityPlans",
  icon: "ni ni-check-bold text-info",
  component: <QualityPlanList />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.QUALITY_READ
},
{
  path: "/quality/inspections",
  name: "Inspections",
  nameKey: "nav.inspections",
  icon: "ni ni-bullet-list-67 text-info",
  component: <InspectionList />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.QUALITY_READ
},
{
  path: "/quality/ncr",
  name: "NCR / CAPA",
  nameKey: "nav.ncr",
  icon: "ni ni-fat-remove text-danger",
  component: <NonConformanceList />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.QUALITY_READ
},
{
  path: "/packaging/finished-goods",
  name: "Finished Goods",
  nameKey: "nav.finishedGoods",
  icon: "ni ni-box-2 text-success",
  component: <FinishedGoodsList />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.PACKAGING_READ
},
{
  path: "/packaging/packages",
  name: "Packages / Pallets",
  nameKey: "nav.packages",
  icon: "ni ni-delivery-fast text-success",
  component: <PackagingList />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.PACKAGING_READ
},
{
  path: "/export/orders",
  name: "Export Orders",
  nameKey: "nav.exportOrders",
  icon: "ni ni-world text-primary",
  component: <ExportOrderList />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.EXPORT_READ
},
{
  path: "/export/shipments",
  name: "Intl Shipments",
  nameKey: "nav.intlShipments",
  icon: "ni ni-delivery-fast text-primary",
  component: <InternationalShipmentList />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.EXPORT_READ
},
{
  path: "/export/containers",
  name: "Containers",
  nameKey: "nav.containers",
  icon: "ni ni-box-2 text-primary",
  component: <ContainerList />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.LOGISTICS_READ
},
{
  path: "/export/forwarders",
  name: "Freight Forwarders",
  nameKey: "nav.forwarders",
  icon: "ni ni-building text-primary",
  component: <FreightForwarderList />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.LOGISTICS_READ
},
{
  path: "/export/customs",
  name: "Customs",
  nameKey: "nav.customs",
  icon: "ni ni-single-copy-04 text-warning",
  component: <CustomsList />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.EXPORT_READ
},
{
  path: "/export/overseas-warehouses",
  name: "Overseas Warehouses",
  nameKey: "nav.overseasWarehouses",
  icon: "ni ni-square-pin text-default",
  component: <OverseasWarehouseList />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.LOGISTICS_READ
},
{
  path: "/sales/customers",
  name: "Customers",
  nameKey: "nav.customers",
  icon: "ni ni-single-02 text-success",
  component: <CustomerList />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.SALES_READ
},
{
  path: "/sales/price-lists",
  name: "Price Lists",
  nameKey: "nav.priceLists",
  icon: "ni ni-money-coins text-success",
  component: <PriceListList />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.SALES_READ
},
{
  path: "/sales/orders",
  name: "Sales Orders",
  nameKey: "nav.salesOrders",
  icon: "ni ni-cart text-success",
  component: <SalesOrderList />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.SALES_READ
},
{
  path: "/sales/waves",
  name: "Wave Picking",
  nameKey: "nav.pickWaves",
  icon: "ni ni-bullet-list-67 text-info",
  component: <PickWaves />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.SALES_READ
},
{
  path: "/sales/fulfillment",
  name: "Fulfillment",
  nameKey: "nav.fulfillment",
  icon: "ni ni-delivery-fast text-info",
  component: <FulfillmentBoard />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.SALES_READ
},
{
  path: "/after-sales/returns",
  name: "Returns",
  nameKey: "nav.returns",
  icon: "ni ni-curved-next text-warning",
  component: <ReturnList />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.AFTERSALES_READ
},
{
  path: "/after-sales/rma",
  name: "RMA",
  nameKey: "nav.rma",
  icon: "ni ni-fat-remove text-danger",
  component: <RmaList />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.AFTERSALES_READ
},
{
  path: "/after-sales/warranty",
  name: "Warranty",
  nameKey: "nav.warranty",
  icon: "ni ni-badge text-info",
  component: <WarrantyList />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.AFTERSALES_READ
},
{
  path: "/after-sales/service",
  name: "Service Orders",
  nameKey: "nav.serviceOrders",
  icon: "ni ni-settings-gear-65 text-default",
  component: <ServiceOrderList />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.AFTERSALES_READ
},
{
  path: "/enterprise/approvals",
  name: "Approval Engine",
  nameKey: "nav.approvalEngine",
  icon: "ni ni-check-bold text-primary",
  component: <ApprovalInbox />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.ENTERPRISE_READ
},
{
  path: "/enterprise/notifications",
  name: "Notification Engine",
  nameKey: "nav.notificationEngine",
  icon: "ni ni-bell-55 text-warning",
  component: <NotificationEngine />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.ENTERPRISE_READ
},
{
  path: "/enterprise/finance",
  name: "Finance Links",
  nameKey: "nav.financeLinks",
  icon: "ni ni-money-coins text-yellow",
  component: <FinanceIntegration />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.ENTERPRISE_READ
},
{
  path: "/enterprise/reports",
  name: "SCM Reports",
  nameKey: "nav.scmReports",
  icon: "ni ni-chart-bar-32 text-info",
  component: <ScmReports />,
  layout: "/admin",
  sidebar: true,
  permission: PERMISSIONS.ENTERPRISE_READ
},
{
  path: "/settings",
  name: "Settings",
  nameKey: "nav.settingsTab",
  icon: "ni ni-settings-gear-65 text-default",
  component: <Settings />,
  layout: "/admin",
  sidebar: true
},

{
  path: "/accounting/invoices/new",
  name: "New Invoice",
  nameKey: "nav.accounting",
  component: <InvoiceCreate />,
  layout: "/admin"
},
{
  path: "/accounting/invoices/:invoiceId",
  name: "Invoice Detail",
  nameKey: "nav.accounting",
  component: <InvoiceDetail />,
  layout: "/admin"
},
{
  path: "/accounting/invoice-ocr/:fileId",
  name: "Invoice OCR",
  nameKey: "nav.ocrResult",
  component: <InvoiceOCR />,
  layout: "/admin"
},
{
  path: "/accounting/accounts/new",
  name: "New Account",
  nameKey: "nav.accounts",
  component: <AccountDetail />,
  layout: "/admin"
},
{
  path: "/accounting/accounts/:id",
  name: "Account Detail",
  nameKey: "nav.accounts",
  component: <AccountDetail />,
  layout: "/admin"
},
{
  path: "/accounting/approvals/new",
  name: "New Approval Request",
  nameKey: "nav.approvals",
  component: <ApprovalDetail />,
  layout: "/admin"
},
{
  path: "/accounting/approvals/:id",
  name: "Approval Detail",
  nameKey: "nav.approvals",
  component: <ApprovalDetail />,
  layout: "/admin"
},

{
  path: "/inventory/products/new",
  name: "New Product",
  nameKey: "nav.inventory",
  component: <ProductCreate />,
  layout: "/admin"
},
{
  path: "/inventory/products/:id",
  name: "Product Detail",
  nameKey: "nav.inventory",
  component: <ProductDetail />,
  layout: "/admin"
},
{
  path: "/inventory/movements/new",
  name: "New Stock Entry",
  nameKey: "nav.movements",
  component: <StockEntry />,
  layout: "/admin",
  permission: PERMISSIONS.INVENTORY_WRITE
},
{
  path: "/inventory/warehouses/:id",
  name: "Warehouse Detail",
  nameKey: "nav.warehouses",
  component: <WarehouseDetail />,
  layout: "/admin",
  permission: PERMISSIONS.INVENTORY_READ
},
{
  path: "/inventory/products/:id/serials",
  name: "Serial Tracking",
  nameKey: "nav.inventory",
  component: <SerialTracking />,
  layout: "/admin"
},
{
  path: "/inventory/products/:id/lots",
  name: "Lot Tracking",
  nameKey: "nav.inventory",
  component: <LotTracking />,
  layout: "/admin",
  permission: PERMISSIONS.INVENTORY_READ
},
{
  path: "/procurement/suppliers/:id",
  name: "Supplier Detail",
  nameKey: "nav.suppliers",
  component: <SupplierDetail />,
  layout: "/admin",
  permission: PERMISSIONS.PROCUREMENT_READ
},
{
  path: "/manufacturing/orders/:id",
  name: "Manufacturing Order",
  nameKey: "nav.manufacturingOrders",
  component: <ManufacturingOrderDetail />,
  layout: "/admin",
  permission: PERMISSIONS.MANUFACTURING_READ
},

{
  path: "/files/upload",
  name: "Upload",
  nameKey: "nav.uploadFile",
  component: <FileUpload />,
  layout: "/admin"
},
{
  path: "/files/:fileId",
  name: "File Detail",
  nameKey: "nav.fileDetail",
  component: <FileDetail />,
  layout: "/admin"
},
{
  path: "/files/:fileId/preview",
  name: "File Preview",
  nameKey: "nav.filePreview",
  component: <FilePreview />,
  layout: "/admin"
},
{
  path: "/files/:fileId/share",
  name: "Share File",
  nameKey: "nav.shareFile",
  component: <FileShare />,
  layout: "/admin"
},
{
  path: "/files/:fileId/versions",
  name: "Version History",
  nameKey: "nav.versionHistory",
  component: <FileVersionHistory />,
  layout: "/admin"
},
{
  path: "/files/:fileId/ocr",
  name: "OCR Result",
  nameKey: "nav.ocrResult",
  component: <OCRResult />,
  layout: "/admin"
},

{
  path: "/folders",
  name: "Folders",
  nameKey: "nav.folderManagement",
  component: <FolderManage />,
  layout: "/admin"
},
{
  path: "/folders/:folderId",
  name: "Folder",
  nameKey: "nav.folderManagement",
  component: <FilesList />,
  layout: "/admin"
},

{
  path: "/settings/profile",
  name: "Profile",
  nameKey: "nav.profile",
  component: <Profile />,
  layout: "/admin"
},
{
  path: "/settings/notifications",
  name: "Notifications",
  nameKey: "nav.notifications",
  component: <Notifications />,
  layout: "/admin"
},
{
  path: "/settings/security",
  name: "Security",
  nameKey: "nav.settingsTab",
  component: <Security />,
  layout: "/admin"
},
{
  path: "/settings/workspace",
  name: "Workspace",
  nameKey: "nav.settingsTab",
  component: <WorkspaceSelector />,
  layout: "/admin"
},
{
  path: "/settings/organization",
  name: "Organization",
  nameKey: "nav.organization",
  component: <Organization />,
  layout: "/admin",
  hideInDemo: true
},
{
  path: "/settings/ai-data-processing",
  name: "AI & OCR Data Processing",
  nameKey: "settings.aiDataProcessing",
  component: <AIDataProcessing />,
  layout: "/admin"
},
{
  path: "/settings/privacy-requests",
  name: "Personal Data Requests",
  nameKey: "settings.privacyRequests",
  component: <PrivacyRequests />,
  layout: "/admin",
  hideInDemo: true
},
{
  path: "/settings/license-verification",
  name: "License Verification",
  nameKey: "settings.licenseVerification",
  component: <LicenseVerification />,
  layout: "/admin"
},

{
  path: "/privacy",
  name: "Privacy Policy",
  nameKey: "nav.privacyPolicy",
  component: <PrivacyPolicy />,
  layout: "/admin"
},
{
  path: "/terms",
  name: "Terms of Service",
  nameKey: "nav.termsOfService",
  component: <TermsOfService />,
  layout: "/admin"
},
{
  path: "/kvkk",
  name: "KVKK",
  nameKey: "nav.kvkk",
  component: <KvkkNotice />,
  layout: "/admin"
},
{
  path: "/distance-sales",
  name: "Distance Sales",
  nameKey: "nav.distanceSales",
  component: <DistanceSalesAgreement />,
  layout: "/admin"
},
{
  path: "/delivery-conditions",
  name: "Delivery Conditions",
  nameKey: "nav.deliveryConditions",
  component: <DeliveryConditions />,
  layout: "/admin"
},
{
  path: "/cancellation-return",
  name: "Cancellation & Return",
  nameKey: "nav.cancellationReturn",
  component: <CancellationReturn />,
  layout: "/admin"
},

{
  path: "/upload",
  name: "Upload (Legacy)",
  component: <FileUpload />,
  layout: "/admin"
},
{
  path: "/file/:fileId",
  name: "File Detail (Legacy)",
  component: <FileDetail />,
  layout: "/admin"
},
{
  path: "/file/:fileId/preview",
  name: "File Preview (Legacy)",
  component: <FilePreview />,
  layout: "/admin"
},
{
  path: "/file/:fileId/share",
  name: "Share File (Legacy)",
  component: <FileShare />,
  layout: "/admin"
},
{
  path: "/file/:fileId/versions",
  name: "Version History (Legacy)",
  component: <FileVersionHistory />,
  layout: "/admin"
},
{
  path: "/file/:fileId/ocr",
  name: "OCR Result (Legacy)",
  component: <OCRResult />,
  layout: "/admin"
},
{
  path: "/profile",
  name: "Profile (Legacy)",
  component: <Profile />,
  layout: "/admin"
},
{
  path: "/notifications",
  name: "Notifications (Legacy)",
  component: <Notifications />,
  layout: "/admin"
},

{
  path: "/login",
  name: "Login",
  icon: "ni ni-key-25 text-info",
  component: <Login />,
  layout: "/auth"
},
{
  path: "/register",
  name: "Register",
  icon: "ni ni-circle-08 text-pink",
  component: <Register />,
  layout: "/auth"
},
{
  path: "/license-lookup",
  name: "License Lookup",
  icon: "ni ni-badge text-default",
  component: <LicenseLookup />,
  layout: "/auth"
},
{
  path: "/license-info",
  name: "License Info",
  component: <LicenseInfo />,
  layout: "/auth"
},
{
  path: "/support-request",
  name: "Support Request",
  component: <SupportRequest />,
  layout: "/auth"
},

{
  path: "/privacy",
  name: "Privacy Policy",
  nameKey: "nav.privacyPolicy",
  component: <PrivacyPolicy />,
  layout: "/auth"
},
{
  path: "/terms",
  name: "Terms of Service",
  nameKey: "nav.termsOfService",
  component: <TermsOfService />,
  layout: "/auth"
},
{
  path: "/kvkk",
  name: "KVKK",
  nameKey: "nav.kvkk",
  component: <KvkkNotice />,
  layout: "/auth"
},
{
  path: "/distance-sales",
  name: "Distance Sales",
  nameKey: "nav.distanceSales",
  component: <DistanceSalesAgreement />,
  layout: "/auth"
},
{
  path: "/delivery-conditions",
  name: "Delivery Conditions",
  nameKey: "nav.deliveryConditions",
  component: <DeliveryConditions />,
  layout: "/auth"
},
{
  path: "/cancellation-return",
  name: "Cancellation & Return",
  nameKey: "nav.cancellationReturn",
  component: <CancellationReturn />,
  layout: "/auth"
}
];

routes = filterConsumerLegalRoutes(routes);

export default routes;
